module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_08@2x-87a63a51cf68cca9ed1fa81edc6e1a78.webp";